import React from "react";
import Modal from "@mui/material/Modal";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import TextView from "../TextView";
import Button from "../Button";
import { colors } from "../../utils";
import { useResendVerificationLink } from "../../services/mutations";
import { toast } from "react-toastify";

// Styled components
const ModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 400px;
  width: 90vw;
  background-color: ${colors.white};
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
  position: relative;

`;

const CloseButton = styled(IconButton)`
  color: ${colors.darkGrey} !important;
`;



const MessageContainer = styled.div`
  text-align: center;
  border-top: 1px solid ${colors.lightBorder};
  border-bottom: 1px solid ${colors.lightBorder};
  padding-top: 16px;
  padding-bottom: 16px;

`;

const EmailAddress = styled.span`
  font-weight: 600;
  color: ${colors.primary};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
`;

const ResendButton = styled(Button)`
  background-color: ${colors.error} !important;
  
  &:hover {
    background-color: #d41e00 !important;
  }
`;

const OkayButton = styled(Button)`
  background-color: ${colors.PrimaryPurple} !important;
  
  &:hover {
    background-color: ${colors.PrimaryPurple700} !important;
  }
`;

const EmailVerificationPopup = ({
  open = false,
  onClose = () => {},
  email = "verifyiyuga@yopmail.com",
  onResend = () => {},
  userName = "Verification Test",
}) => {

    const resendVerification = useResendVerificationLink();

    const handleResendVerification = () => {
        resendVerification.mutate(
          {
            email: email,
          },
          {
            onSuccess: (response) => {
              toast.success("Verification email has been resent successfully");
            },
            onError: (err) => {
              toast.error(
                err.response?.data?.message ||
                  "Failed to resend verification email. Please try again."
              );
            },
          }
        );
      };

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <ModalContainer>
        <Header>
            <div>
            <TextView variant="subtitle">
          Verify your email
        </TextView>
            </div>
          <CloseButton onClick={onClose} size="small">
            <CloseIcon />
          </CloseButton>
        </Header>
        
        <MessageContainer>
          <TextView variant="text" style={{ lineHeight: "1.5" }}>
           Please verify your email address by clicking the link sent to{" "}
            <br/><EmailAddress>{email}</EmailAddress>
          </TextView>
        </MessageContainer>
        
        <ButtonContainer>
          <ResendButton 
            onClick={handleResendVerification}
            style={{ flex: 1 }}
          >
            Resend
          </ResendButton>
          <OkayButton 
            onClick={onClose}
            style={{ flex: 1 }}
          >
            Okay
          </OkayButton>
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  );
};

export default EmailVerificationPopup; 